import React, { useState, useEffect, useRef } from "react";
import { Col, Container, Row, Alert } from "react-bootstrap";
import { TextInputForm, DropDownUI, Calender } from "../../components/Forms";
import { ClickButton, ChooseButton } from "../../components/ClickButton";
import PageNav from "../../components/PageNav";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import API_DOMAIN from "../../config/config";

import debounce from "lodash.debounce";


const UserCreation = () => {
  const location = useLocation();
  const { type, rowData } = location.state || {};
  const fileInputRef = useRef(null);
  const aadharFileInputRef = useRef(null);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [suggestions, setSuggestions] = useState([]);
  const [searchText, setSearchText] = useState("");
console.log("suggestions:", suggestions);
  console.log("searchText:", searchText);




  const today = new Date();
  const defaultDate = today.toISOString().substr(0, 10);

  const initialState =
    type === "edit"
      ? {
        ...rowData,
        pawnjewelry_date: rowData.pawnjewelry_date,
        proof: Array.isArray(rowData.proof_base64code)
          ? rowData.proof_base64code
            .filter((base64) => base64 && typeof base64 === "string")
            .map((base64, index) => {
              const mimeMatch = base64.match(
                /^data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.]+);base64,/
              );
              const mimeType = mimeMatch ? mimeMatch[1] : "";
              const extension = mimeType.split("/")[1] || "unknown";
              const isImage = [
                "jpg",
                "jpeg",
                "png",
                "gif",
                "webp",
              ].includes(extension);
              const base64WithPrefix = mimeMatch
                ? base64
                : `data:image/${extension || "jpeg"};base64,${base64}`;
              const fileName =
                rowData.proof && rowData.proof[index]
                  ? rowData.proof[index].split("/").pop()
                  : `file_${index}.${extension || "jpeg"}`;
              return {
                data: base64WithPrefix,
                name: fileName,
                type: isImage ? "image" : extension,
              };
            })
          : [],
        aadharproof: Array.isArray(rowData.aadharproof_base64code)
          ? rowData.aadharproof_base64code
            .filter((base64) => base64 && typeof base64 === "string")
            .map((base64, index) => {
              const mimeMatch = base64.match(
                /^data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.]+);base64,/
              );
              const mimeType = mimeMatch ? mimeMatch[1] : "";
              const extension = mimeType.split("/")[1] || "unknown";
              const isImage = [
                "jpg",
                "jpeg",
                "png",
                "gif",
                "webp",
              ].includes(extension);
              const base64WithPrefix = mimeMatch
                ? base64
                : `data:image/${extension || "jpeg"};base64,${base64}`;
              const fileName =
                rowData.aadharproof && rowData.aadharproof[index]
                  ? rowData.aadharproof[index].split("/").pop()
                  : `aadhar_file_${index}.${extension || "jpeg"}`;
              return {
                data: base64WithPrefix,
                name: fileName,
                type: isImage ? "image" : extension,
              };
            })
          : [],
      }
      : {
        customer_no: "",
        receipt_no: "",
        name: "",
        pawnjewelry_date: defaultDate,
        customer_details: "",
        place: "",
        mobile_number: "",
        original_amount: "",
        interest_rate: "",
        pledged_items: "",
        item: "",
        jewel_weight: "",
        net_weight: "",
        total_weight: "",
        Jewelry_recovery_agreed_period: "1 Year",
        proof: [],
        aadharproof: [],
        group_type: "",
      };

  const [formData, setFormData] = useState(initialState);
  console.log(formData);
  console.log("Loaded Proof Files:", formData.proof);
  console.log("Loaded aadharproof Files:", formData.aadharproof);
  const [grupData, setGrupData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [showCapturePage, setShowCapturePage] = useState(false);
  const [stream, setStream] = useState(null);
  const [previewFile, setPreviewFile] = useState(null);

const fetchCustomerSuggestions = debounce(async (text) => {
    if (!text) return;

    setLoading(true);
    try {
      const response = await fetch(`${API_DOMAIN}/customer.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          search_text: text,
          limit: 5,
          offset: 0,
        }),
      });

      const responseData = await response.json();
      if (responseData.head.code === 200) {
        console.log("Customer suggestions:", responseData.body.customer);
        setSuggestions(responseData.body.customer || []);
      } else {
        setSuggestions([]);
      }
    } catch (error) {
      console.error("Suggestion fetch error:", error.message);
      setSuggestions([]);
    } finally {
      setLoading(false);
    }
  }, 400);

  const handleChange = async (e, field) => {
    const { value } = e.target;

    // Update form data
    let updatedFormData = {
      ...formData,
      [field]: value,
    };

    // Calculate total weight if jewel_weight or net_weight changes
    const jewelWeight = parseFloat(field === "jewel_weight" ? value : formData.jewel_weight) || 0;
    const netWeight = parseFloat(field === "net_weight" ? value : formData.net_weight) || 0;
    const totalWeight = jewelWeight - netWeight;
    updatedFormData.total_weight = totalWeight > 0 ? totalWeight.toFixed(2) : "0.00";

    // Handle customer_no or mobile_number input
    if (field === "customer_no" || field === "mobile_number") {
      setSearchText(value);
      if (value.trim() === "") {
        // Clear all customer-related fields when input is empty
        updatedFormData = {
          ...updatedFormData,
          customer_no: "",
          name: "",
          customer_details: "",
          place: "",
          mobile_number: "",
          proof: [],
          aadharproof: [],
        };
        setSuggestions([]);
      
        if (fileInputRef.current) fileInputRef.current.value = "";
        if (aadharFileInputRef.current) aadharFileInputRef.current.value = "";
      } else {
      
        fetchCustomerSuggestions(value);
      }
    }
    setFormData(updatedFormData);
  };


  

  const processBase64Array = (base64Array, originalNames, prefix) => {
    return Array.isArray(base64Array)
      ? base64Array
        .filter((b64) => typeof b64 === "string" && b64)
        .map((b64, index) => {
          const mimeMatch = b64.match(/^data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.]+);base64,/);
          const mimeType = mimeMatch ? mimeMatch[1] : "image/jpeg";
          const extension = mimeType.split("/")[1] || "jpeg";
          const base64WithPrefix = mimeMatch ? b64 : `data:${mimeType};base64,${b64}`;
          const fileName = originalNames?.[index]?.split("/")?.pop() || `${prefix}_${index}.${extension}`;
          return {
            data: base64WithPrefix,
            name: fileName,
            type: ["jpg", "jpeg", "png", "webp", "gif"].includes(extension) ? "image" : extension,
          };
        })
      : [];
  };

 const handleCustomerSelect = (customer) => {
    const formattedData = {
      ...formData,
      customer_no: customer.customer_no || "",
      name: customer.name || "",
      customer_details: customer.customer_details || "",
      place: customer.place || "",
      mobile_number: customer.mobile_number || "",
      proof: processBase64Array(customer.proof_base64code, customer.proof, "file"),
      aadharproof: processBase64Array(customer.aadharproof_base64code, customer.aadharproof, "aadhar_file"),
    };

    setFormData(formattedData);
    setSuggestions([]);
    document.activeElement.blur();
  };


  const handleGroupTypeChange = (e) => {
    const selectedGroupType = e.target.value;
    const selectedGroup = grupData.find(
      (group) => group.Group_type === selectedGroupType
    );
    setFormData((prevData) => ({
      ...prevData,
      group_type: selectedGroupType,
      interest_rate: selectedGroup
        ? selectedGroup.interest
        : prevData.interest_rate,
    }));
  };

  const handleFileChange = (files, field) => {
    if (files && files.length > 0) {
      const fileArray = Array.from(files);
      const maxSize = 5 * 1024 * 1024;

      fileArray.forEach((file) => {
        if (file.size > maxSize) {
          toast.error(`${file.name} exceeds 5MB limit.`, {
            position: "top-center",
            autoClose: 2000,
            theme: "colored",
          });
          return;
        }

        const reader = new FileReader();

        reader.onloadend = () => {
          if (file.type.startsWith("image/")) {
            setFormData((prevData) => ({
              ...prevData,
              [field]: [
                ...prevData[field],
                { type: "image", data: reader.result, name: file.name },
              ],
            }));
          } else if (file.type === "application/pdf") {
            setFormData((prevData) => ({
              ...prevData,
              [field]: [
                ...prevData[field],
                { type: "pdf", data: reader.result, name: file.name },
              ],
            }));
          } else {
            toast.error(`${file.name}: Only images and PDFs are allowed.`, {
              position: "top-center",
              autoClose: 2000,
              theme: "colored",
            });
          }
        };

        reader.onerror = () => {
          toast.error(`Failed to read ${file.name}.`, {
            position: "top-center",
            autoClose: 2000,
            theme: "colored",
          });
        };

        reader.readAsDataURL(file);
      });

      toast.success("File(s) uploaded successfully!", {
        position: "top-center",
        autoClose: 2000,
        theme: "colored",
      });
    } else {
      toast.error("Please select valid files.", {
        position: "top-center",
        autoClose: 2000,
        theme: "colored",
      });
    }
  };

  const handleImageDelete = (index, field) => {
    const newFiles = formData[field].filter((_, i) => i !== index);
    setFormData({ ...formData, [field]: newFiles });

    if (newFiles.length === 0) {
      if (field === "proof" && fileInputRef.current) {
        fileInputRef.current.value = "";
      } else if (field === "aadharproof" && aadharFileInputRef.current) {
        aadharFileInputRef.current.value = "";
      }
    }

    toast.info("File removed successfully!", {
      position: "top-center",
      autoClose: 2000,
      theme: "colored",
    });
  };

  const handlePreview = (file) => {
    setPreviewFile(file);
  };

  const closePreview = () => {
    setPreviewFile(null);
  };

  const setLabel = (date, label) => {
    let dateString =
      date instanceof Date ? date.toISOString().substr(0, 10) : date;
    if (!dateString || isNaN(new Date(dateString))) {
      console.error("Invalid date:", date);
      return;
    }
    setFormData((prevData) => ({
      ...prevData,
      [label]: dateString,
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_DOMAIN}/pawnjewelry.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...formData,
          proof: formData.proof.map((file) => ({ data: file.data })),
          aadharproof: formData.aadharproof.map((file) => ({
            data: file.data,
          })),
        }),
      });

      const responseData = await response.json();
      console.log("API Response:", responseData);

      if (responseData.head.code === 200) {
        setLoading(false);
        toast.success(responseData.head.msg, {
          position: "top-center",
          autoClose: 2000,
        });

        setTimeout(() => {
          navigate("/console/pawn/jewelpawning");
          window.location.reload();
        }, 1000);
      } else {
        toast.error(responseData.head.msg, {
          position: "top-center",
          autoClose: 2000,
        });
        console.error("API Error:", responseData.head.msg);
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      toast.error("Failed to submit data. Please try again.", {
        position: "top-center",
        autoClose: 2000,
      });
    }
    setLoading(false);
  };

  const handleUpdateSubmit = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_DOMAIN}/pawnjewelry.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          edit_pawnjewelry_id: rowData.pawnjewelry_id,
          customer_no: formData.customer_no,
          receipt_no: formData.receipt_no,
          pawnjewelry_date: formData.pawnjewelry_date,
          name: formData.name,
          customer_details: formData.customer_details,
          place: formData.place,
          mobile_number: formData.mobile_number,
          original_amount: formData.original_amount,
          interest_rate: formData.interest_rate,
          pledged_items: formData.pledged_items,
          item: formData.item,
          jewel_weight: formData.jewel_weight,
          net_weight: formData.net_weight,
          total_weight: formData.total_weight,
          Jewelry_recovery_agreed_period:
            formData.Jewelry_recovery_agreed_period,
          group_type: formData.group_type,
          proof: formData.proof.map((file) => ({ data: file.data })),
          aadharproof: formData.aadharproof.map((file) => ({
            data: file.data,
          })),
        }),
      });

      const responseData = await response.json();
      console.log("Update Response:", responseData);

      if (responseData.head.code === 200) {
        toast.success(responseData.head.msg, {
          position: "top-center",
          autoClose: 2000,
        });
        setTimeout(() => {
          navigate("/console/pawn/jewelpawning");
        }, 2000);
      } else {
        toast.error(responseData.head.msg, {
          position: "top-center",
          autoClose: 2000,
        });
        console.error("API Error:", responseData.head.msg);
      }
    } catch (error) {
      console.error("Error updating data:", error);
      toast.error("Failed to update data. Please try again.", {
        position: "top-center",
        autoClose: 2000,
      });
    }
    setLoading(false);
  };

  const fetchgroup = async () => {
    try {
      const response = await fetch(`${API_DOMAIN}/group.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ search_text: "" }),
      });

      const responseData = await response.json();
      console.log("groupresponseData", responseData);
      setLoading(false);
      if (responseData.head.code === 200) {
        setGrupData(responseData.body.group);
      } else {
        throw new Error(responseData.head.msg);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error.message);
    }
  };

  // const fetchDatajewelpawncustomer = async () => {
  //   try {
  //     const response = await fetch(`${API_DOMAIN}/customer.php`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         search_text: "",
  //       }),
  //     });

  //     const responseData = await response.json();
  //     console.log("customerdata", responseData);
  //     setLoading(false);
  //     if (responseData.head.code === 200) {
  //       setcustomerData(responseData.body.customer);
  //     } else {
  //       throw new Error(responseData.head.msg);
  //     }
  //   } catch (error) {
  //     setLoading(false);
  //     console.error("Error fetching data:", error.message);
  //   }
  // };

  const startWebcam = async (fieldType) => {
    try {
      const mediaStream = await navigator.mediaDevices.getUserMedia({
        video: {
          width: { ideal: 1280 },
          height: { ideal: 720 },
          facingMode: "environment",
        },
      });
      setStream(mediaStream);
      setShowCapturePage(true);
      setFormData((prevData) => ({ ...prevData, captureFieldType: fieldType }));
      setTimeout(() => {
        if (videoRef.current) {
          videoRef.current.srcObject = mediaStream;
          videoRef.current.play().catch((err) => {
            console.error("Error playing video:", err);
            toast.error("Failed to play webcam feed.", {
              position: "top-center",
              autoClose: 2000,
              theme: "colored",
            });
          });
        }
      }, 100);
    } catch (err) {
      toast.error(
        "Failed to access webcam. Please ensure camera permissions are granted.",
        {
          position: "top-center",
          autoClose: 2000,
          theme: "colored",
        }
      );
      console.error("Error accessing webcam:", err);
      setShowCapturePage(false);
    }
  };

  const stopWebcam = () => {
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
      setStream(null);
      if (videoRef.current) {
        videoRef.current.srcObject = null;
      }
    }
  };

  const captureImage = () => {
    if (videoRef.current && canvasRef.current) {
      const context = canvasRef.current.getContext("2d");
      canvasRef.current.width = videoRef.current.videoWidth;
      canvasRef.current.height = videoRef.current.videoHeight;
      context.drawImage(videoRef.current, 0, 0);
      const dataUrl = canvasRef.current.toDataURL("image/jpeg", 0.9);
      const fieldType = formData.captureFieldType || "proof";
      setFormData((prevData) => ({
        ...prevData,
        [fieldType]: [
          ...prevData[fieldType],
          {
            type: "image",
            data: dataUrl,
            name: `captured_${Date.now()}.jpeg`,
          },
        ],
      }));
      toast.success("Image captured successfully!", {
        position: "top-center",
        autoClose: 2000,
        theme: "colored",
      });
      stopWebcam();
      setShowCapturePage(false);
    }
  };

  useEffect(() => {
    fetchgroup();
    //  fetchDatajewelpawncustomer();

    return () => {
      stopWebcam();
    };
  }, [type]);

  if (showCapturePage) {
    return (
      <div
        style={{
          height: "80vh",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#f5f5f5",
        }}
      >
        <Container fluid>
          <Row className="py-3">
            <Col>
              <h3>Capture Image</h3>
            </Col>
            <Col className="text-end">
              <ClickButton
                label="Close"
                onClick={() => {
                  stopWebcam();
                  setShowCapturePage(false);
                }}
              />
            </Col>
          </Row>
          <Row
            style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
          >
            <Col xs={12} md={8} lg={6} className="text-center">
              <video
                ref={videoRef}
                autoPlay
                muted
                playsInline
                style={{
                  width: "100%",
                  maxHeight: "70vh",
                  backgroundColor: "black",
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
              />
              <canvas ref={canvasRef} style={{ display: "none" }} />
              <div className="mt-3">
                <ChooseButton label="Capture" onClick={captureImage} />
                <ChooseButton
                  label="Cancel"
                  onClick={() => {
                    stopWebcam();
                    setShowCapturePage(false);
                  }}
                  style={{ marginLeft: "10px" }}
                />
                <ChooseButton
                  label="Gallery"
                  onClick={() => {
                    stopWebcam();
                    setShowCapturePage(false);
                    setTimeout(() => {
                      const fieldType = formData.captureFieldType || "proof";
                      const inputRef =
                        fieldType === "proof"
                          ? fileInputRef
                          : aadharFileInputRef;
                      if (inputRef.current) {
                        inputRef.current.click();
                      }
                    }, 0);
                  }}
                  style={{ marginLeft: "10px" }}
                />
              </div>
            </Col>
          </Row>
        </Container>
        <input
          type="file"
          id="proof"
          accept=".pdf,image/*"
          ref={fileInputRef}
          multiple
          onChange={(e) => handleFileChange(e.target.files, "proof")}
          style={{ display: "none" }}
        />
        <input
          type="file"
          id="aadharproof"
          accept=".pdf,image/*"
          ref={aadharFileInputRef}
          multiple
          onChange={(e) => handleFileChange(e.target.files, "aadharproof")}
          style={{ display: "none" }}
        />
      </div>
    );
  }

  return (
    <div>
      <Container fluid>
        <Row className="regular">
          <Col lg="12" md="6" xs="12" className="py-3">
            <PageNav
              pagetitle={`நகை அடகு${type === "view"
                  ? " வியூ "
                  : type === "edit"
                    ? " எடிட் "
                    : " உருவாக்கம்"
                }`}
            ></PageNav>
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"வாடிக்கையாளர் எண்"}
              labelname={"வாடிக்கையாளர் எண்"}
              name="customer_no"
              value={formData.customer_no}
              onChange={(e) => handleChange(e, "customer_no")}
            >
              {searchText.trim() &&  suggestions.length > 0 && (
                <ul className="suggestion-list">
                  {suggestions.map((cust, idx) => (
                    <li key={idx} onClick={() => handleCustomerSelect(cust)}>
                      {cust.customer_no} - {cust.name} ({cust.mobile_number})
                    </li>
                  ))}
                </ul>
               )}
            </TextInputForm>
          </Col>


          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"அடகு எண்"}
              labelname={"அடகு எண்"}
              name="receipt_no"
              value={formData.receipt_no}
              onChange={(e) => handleChange(e, "receipt_no")}
            ></TextInputForm>
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <Calender
              setLabel={(date) => setLabel(date, "pawnjewelry_date")}
              initialDate={
                type === "edit" ? formData.pawnjewelry_date : undefined
              }
              calenderlabel="தேதி"
              disabled={type === "view" || type === "edit"}
            />
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"பெயர்"}
              labelname={"பெயர்"}
              name="name"
              value={formData.name}
              onChange={(e) => handleChange(e, "receipt_no")}
            ></TextInputForm>
          </Col>
          {/* <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"முகவரி"}
              labelname={"முகவரி"}
              name="customer_details"
              value={formData.customer_details}
              onChange={(e) => handleChange(e, "customer_details")}
            />
          </Col> */}

          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"இடம்"}
              labelname={"இடம்"}
              name="place"
              value={formData.place}
              onChange={(e) => handleChange(e, "place")}
            />
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"மொபைல் எண்"}
              labelname={"மொபைல் எண்"}
              name="mobile_number"
              value={formData.mobile_number}
              onChange={(e) => handleChange(e, "mobile_number")}
            >
              {suggestions.length > 0 && (
                <ul className="suggestion-list">
                  {suggestions.map((cust, idx) => (
                    <li key={idx} onClick={() => handleCustomerSelect(cust)}>
                      {cust.mobile_number} - {cust.name} ({cust.customer_no})
                    </li>
                  ))}
                </ul>
              )}
            </TextInputForm>
          </Col>


          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"அசல் தொகை"}
              labelname={"அசல் தொகை"}
              name="original_amount"
              value={formData.original_amount}
              onChange={(e) => handleChange(e, "original_amount")}
            ></TextInputForm>
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <div className="form-group ">
              <label className="py-1">குழு வகை</label>
              <select
                className="form-cntrl-bt w-100 p-1"
                name="group_type"
                value={formData.group_type}
                onChange={handleGroupTypeChange}
                disabled={type === "view"}
              >
                <option value="">குழு தேர்ந்தெடு</option>
                {grupData.map((group) => (
                  <option key={group.Group_id} value={group.Group_type}>
                    {group.Group_type}
                  </option>
                ))}
              </select>
            </div>
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"வட்டி விகிதம்"}
              labelname={"வட்டி விகிதம்"}
              name="interest_rate"
              value={formData.interest_rate}
              onChange={(e) => handleChange(e, "interest_rate")}
              disabled={type === "view" || formData.group_type} // Disable if group_type is selected
            ></TextInputForm>
          </Col>

          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"அடகு பொருட்கள்"}
              labelname={"அடகு பொருட்கள்"}
              name="pledged_items"
              value={formData.pledged_items}
              onChange={(e) => handleChange(e, "pledged_items")}
            />
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"உருப்படி"}
              labelname={"உருப்படி"}
              name="item"
              value={formData.item}
              onChange={(e) => handleChange(e, "item")}
            ></TextInputForm>
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"நகை எடை"}
              labelname={"நகை எடை"}
              name="jewel_weight"
              value={formData.jewel_weight}
              onChange={(e) => handleChange(e, "jewel_weight")}
            ></TextInputForm>
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"S/WGT எடை"}
              labelname={"S/WGT எடை"}
              name="net_weight"
              value={formData.net_weight}
              onChange={(e) => handleChange(e, "net_weight")}
            ></TextInputForm>
          </Col>
          <Col lg="3" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"மொத்த எடை"}
              labelname={"மொத்த எடை"}
              name="total_weight"
              value={formData.total_weight}
              onChange={(e) => handleChange(e, "total_weight")}
            ></TextInputForm>
          </Col>
          <Col lg="4" md="4" xs="12" className="py-3">
            <TextInputForm
              placeholder={"நகை மீட்பு ஒப்புக்கொண்ட காலம்"}
              labelname={"நகை மீட்பு ஒப்புக்கொண்ட காலம்"}
              name="Jewelry_recovery_agreed_period"
              value={formData.Jewelry_recovery_agreed_period}
              onChange={(e) =>
                handleChange(e, "Jewelry_recovery_agreed_period")
              }
            ></TextInputForm>
          </Col>
          <Col lg="4" md="4" xs="12" className="py-5">
            <div className="file-upload">
              <label>
                {type === "edit" ? "Preview Proof" : "சான்று பதிவேற்றம்"}
              </label>
              <input
                type="file"
                id="proof"
                accept=".pdf,image/*"
                ref={fileInputRef}
                multiple
                onChange={(e) => handleFileChange(e.target.files, "proof")}
                style={{ display: "none" }}
              />
              <ChooseButton
                label="Choose File"
                onClick={() => startWebcam("proof")}
                className="choosefilebtn"
              />
              {formData.proof && formData.proof.length > 0 && (
                <div className="file-preview mt-2">
                  {formData.proof.map((file, index) => (
                    <div
                      key={index}
                      className="file-item d-flex align-items-center mb-2"
                    >
                      {file.type === "image" ? (
                        <img
                          src={file.data}
                          alt={`Preview ${file.name}`}
                          onError={(e) => {
                            e.target.src = "/assets/fallback-image.png";
                            toast.error(`Failed to load image: ${file.name}`, {
                              position: "top-center",
                              autoClose: 2000,
                              theme: "colored",
                            });
                          }}
                          style={{
                            width: "100px",
                            height: "100px",
                            marginRight: "10px",
                            objectFit: "cover",
                            borderRadius: "5px",
                          }}
                        />
                      ) : (
                        <div
                          className="file-info"
                          style={{ marginRight: "10px" }}
                        >
                          <p>
                            <a
                              href={file.data}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {file.name}
                            </a>{" "}
                            ({file.type ? file.type.toUpperCase() : "UNKNOWN"})
                          </p>
                        </div>
                      )}
                      <ChooseButton
                        label="Preview"
                        className="btn btn-primary btn-sm me-2"
                        onClick={() => handlePreview(file)}
                      />
                      <ChooseButton
                        label="Delete"
                        className="btn btn-danger btn-sm"
                        onClick={() => handleImageDelete(index, "proof")}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </Col>
          <Col lg="4" md="4" xs="12" className="py-5">
            <div className="file-upload">
              <label>
                {type === "edit"
                  ? "Preview Aadhaar Proof"
                  : "Upload Aadhaar Proof"}
              </label>
              <input
                type="file"
                id="aadharproof"
                accept=".pdf,image/*"
                ref={aadharFileInputRef}
                multiple
                onChange={(e) =>
                  handleFileChange(e.target.files, "aadharproof")
                }
                style={{ display: "none" }}
              />
              {/* <ChooseButton
                label="Choose Aadhaar File"
                onClick={() => startWebcam("aadharproof")}
                className="choosefilebtn"
              /> */}
              {formData.aadharproof && formData.aadharproof.length > 0 && (
                <div className="file-preview mt-2">
                  {formData.aadharproof.map((file, index) => (
                    <div
                      key={index}
                      className="file-item d-flex align-items-center mb-2"
                    >
                      {file.type === "image" ? (
                        <img
                          src={file.data}
                          alt={`Preview ${file.name}`}
                          onError={(e) => {
                            e.target.src = "/assets/fallback-image.png";
                            toast.error(`Failed to load image: ${file.name}`, {
                              position: "top-center",
                              autoClose: 2000,
                              theme: "colored",
                            });
                          }}
                          style={{
                            width: "100px",
                            height: "100px",
                            marginRight: "10px",
                            objectFit: "cover",
                            borderRadius: "5px",
                          }}
                        />
                      ) : (
                        <div
                          className="file-info"
                          style={{ marginRight: "10px" }}
                        >
                          <p>
                            <a
                              href={file.data}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {file.name}
                            </a>{" "}
                            ({file.type ? file.type.toUpperCase() : "UNKNOWN"})
                          </p>
                        </div>
                      )}
                      <ChooseButton
                        label="Preview"
                        className="btn btn-primary btn-sm me-2"
                        onClick={() => handlePreview(file)}
                      />
                      {/* <ChooseButton
                        label="Delete"
                        className="btn btn-danger btn-sm"
                        onClick={() => handleImageDelete(index, "aadharproof")}
                      /> */}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </Col>
          <Col lg="12">
            <div className="text-center mb-3">
              {type === "view" ? (
                <span className="mx-2">
                  <ClickButton
                    label={<>Back</>}
                    onClick={() => navigate("/console/pawn/jewelpawning")}
                  />
                </span>
              ) : (
                <>
                  {type === "edit" ? (
                    <>
                      <ToastContainer
                        position="top-center"
                        autoClose={2000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="colored"
                      />
                      <span className="mx-2">
                        <ClickButton
                          label={<>Update</>}
                          onClick={handleUpdateSubmit}
                          disabled={loading}
                        />
                      </span>
                      <span className="mx-2">
                        <ClickButton
                          label={<>Cancel</>}
                          onClick={() => navigate("/console/pawn/jewelpawning")}
                        />
                      </span>
                    </>
                  ) : (
                    <>
                      <ToastContainer
                        position="top-center"
                        autoClose={2000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="colored"
                      />
                      <span className="px-2">
                        <ClickButton
                          label={<>Submit</>}
                          onClick={handleSubmit}
                          disabled={loading}
                        ></ClickButton>
                      </span>
                      <span className="px-2">
                        <ClickButton
                          label={<>Cancel</>}
                          onClick={() => navigate("/console/pawn/jewelpawning")}
                          disabled={loading}
                        ></ClickButton>
                      </span>
                    </>
                  )}
                </>
              )}
            </div>
          </Col>
        </Row>
      </Container>
      {previewFile && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              position: "relative",
              backgroundColor: "#fff",
              padding: "20px",
              borderRadius: "8px",
              maxWidth: "100%",
              maxHeight: "100%",
              overflow: "auto",
            }}
          >
            <button
              onClick={closePreview}
              style={{
                position: "absolute",
                top: "1px",
                right: "1px",
                background: "black",
                border: "none",
                fontSize: "24px",
                cursor: "pointer",
                color: "#333",
              }}
            >
              ×
            </button>
            {previewFile.type === "image" ? (
              <img
                src={previewFile.data}
                alt={`Preview ${previewFile.name}`}
                style={{
                  maxWidth: "100%",
                  maxHeight: "80vh",
                  objectFit: "contain",
                }}
                onError={() =>
                  toast.error(`Failed to load image: ${previewFile.name}`, {
                    position: "top-center",
                    autoClose: 2000,
                    theme: "colored",
                  })
                }
              />
            ) : (
              <iframe
                src={previewFile.data}
                title={`Preview ${previewFile.name}`}
                style={{
                  width: "100%",
                  height: "80vh",
                  border: "none",
                }}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default UserCreation;
